/* eslint-disable */
import * as R from 'ramda'
import dayjs from 'dayjs'
import numeral from 'numeral'

// ** 树结构数据渲染  **/
// ** 只做 父仔 关系链接
function renderChilderTree (root, grouByData) {
  for ( let i = 0; i < root.length; i++) {
    const item = root[i]
    if (grouByData[item.id]) {
      item.children = grouByData[item.id]
      renderChilderTree(item.children, grouByData)
    }
  }
}
export function renderTree (grouByData) {
  let treeData = grouByData[0] || []
  renderChilderTree(treeData, grouByData)
  return treeData
}
// ** 树结构数据渲染  **/

export function promisify (fn) {
  return function (...args) {
    return new Promise(function (resolve, reject) {
      fn((error, values) => {
        console.log('error', error)
        if (error) {
          if (Object.keys(error)[0] !== 'message') {
            const oKeys = Object.keys(error)
            return reject(error[oKeys[0]].errors[0])
          }
          return reject(error)
        }
        resolve(values)
      })
    })
  }
}

export function objToFormData (obj = {}) {
  /* eslint-disable no-undef */
  const formData = new FormData()
  Object.keys(obj).forEach(key => {
    let item = obj[key]
    // 去掉前后空格
    if (typeof item === 'string') {
      item = item.trim()
    }
    if (Array.isArray(item)) {
      item.forEach(value => formData.append(key, fixNullVaue(value)))
    } else {
      formData.append(key, fixNullVaue(item))
    }
  })
  return formData
}

export function fixNullVaue (value) {
  /* eslint-disable */
  if (
    (typeof value === 'object' && !value) ||
    typeof value === 'null' ||
    typeof value === 'undefined'
  ) {
    return ''
  }
  return value
}

export function filterEmpty (obj) {
  return Object.keys(obj).filter(key => {
    const value = obj[key]
    if (Array.isArray(value)) {
      return value.length > 0
    } else if (typeof value === 'object') {
      return Object.keys(value || {}).length > 0
    } else {
      return value !== '' && value !== null && value !== undefined
    }
  }).reduce((newObj, key) => {
    newObj[key] = obj[key]
    return newObj
  }, {})
}

export function objToQuerystring (obj = {}) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      R.mergeRight(obj, (obj[key] = ''))
    }
  }
  return Object.keys(obj)
    .reduce((query, key) => query.concat(`${key}=${obj[key]}`), [])
    .join('&')
}

export function objToSearch (obj = {}) {
  const queryString = objToQuerystring(obj)
  return queryString ? `?${queryString}` : queryString
}

export function parseQueryString (search, key) {
  if (!search) {
    return key ? undefined : {}
  }

  search = search.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '')

  let query = {}
  const splits = search.split('&')

  splits.forEach(item => {
    const v = item.split('=')
    const name = decodeURIComponent(v.shift())
    const value = v.length ? decodeURIComponent(v.join('=')) : null

    if (Object.hasOwnProperty.call(query, name)) {
      if (typeof query[name] === 'string' || query[name] === null) {
        query[name] = [query[name]]
      }
      query[name] = value
    } else {
      query[name] = value
    }
  })

  return key ? query[key] : query
}

/**
 * 解析 token（MD5 哈希值）
 * 由于 MD5 是单向哈希，无法从中解析信息，返回 token 本身
 * 用户信息需要从后端 API 获取
 */
export function parseToken (token) {
  try {
    if (!token || typeof token !== 'string') {
      return null
    }
    // MD5 哈希值通常是 32 位十六进制字符串
    // 验证格式是否为有效的 MD5 哈希
    const md5Regex = /^[a-f0-9]{32}$/i
    if (md5Regex.test(token)) {
      return { token } // 返回包含 token 的对象，保持兼容性
    }
    return null
  } catch (error) {
    return null
  }
}

/**
 * 检查 token 是否有效（7 天有效期）
 * token 是 MD5 哈希值，需要配合存储的创建时间进行验证
 */
export function checkToken (token) {
  try {
    if (!token || typeof token !== 'string') {
      return false
    }
    
    // 验证 token 格式（MD5 哈希值应该是 32 位十六进制字符串）
    const md5Regex = /^[a-f0-9]{32}$/i
    if (!md5Regex.test(token)) {
      return false
    }
    
    // 从 localStorage 获取 token 的创建时间
    const tokenKey = `token_${token}`
    let tokenData = localStorage.getItem(tokenKey)
    
    // 如果没有存储创建时间，自动保存当前时间（表示这是新 token，兼容旧代码）
    if (!tokenData) {
      saveTokenWithTimestamp(token)
      tokenData = localStorage.getItem(tokenKey)
    }
    
    if (!tokenData) {
      return false
    }
    
    try {
      const { createdAt } = JSON.parse(tokenData)
      if (!createdAt) {
        return false
      }
      
      // 计算是否在 7 天内
      const createdAtTime = dayjs(createdAt)
      const now = dayjs()
      const daysDiff = now.diff(createdAtTime, 'day')
      
      // 有效期 7 天
      return daysDiff < 7
    } catch (error) {
      return false
    }
  } catch (error) {
    return false
  }
}

/**
 * 保存 token 及其创建时间到 localStorage
 * 用于后续验证 token 是否在 7 天有效期内
 */
export function saveTokenWithTimestamp (token) {
  try {
    if (!token || typeof token !== 'string') {
      return false
    }
    
    const tokenKey = `token_${token}`
    const tokenData = {
      token,
      createdAt: dayjs().toISOString()
    }
    
    localStorage.setItem(tokenKey, JSON.stringify(tokenData))
    return true
  } catch (error) {
    console.error('保存 token 时间戳失败:', error)
    return false
  }
}

/**
 * 退出登录时清除当前 token 在 localStorage 中的时间戳
 */
export function clearTokenWithTimestamp (token) {
  try {
    if (!token || typeof token !== 'string') return
    const tokenKey = `token_${token}`
    localStorage.removeItem(tokenKey)
  } catch (error) {
    console.error('清除 token 时间戳失败:', error)
  }
}


export function getDateRangeList(startTimestamp, endTimestamp) {
  startTimestamp = +startTimestamp
  endTimestamp = +endTimestamp

  if (
    typeof startTimestamp !== 'number' &&
    typeof endTimestamp !== 'number' ||
    endTimestamp < startTimestamp
  ) {
    return []
  }

  const durationDays = dayjs(endTimestamp).diff(dayjs(startTimestamp), 'day') + 1
  const dateRangeList = []
  for (let i = 0; i < durationDays; i++) {
    dateRangeList.push(dayjs(startTimestamp).add(i, 'days').format('YYYY-MM-DD'))
  }

  return dateRangeList
}

// 获取月份区间 数组
export function getMonthRangeList(startTimestamp, endTimestamp) {
  startTimestamp = +dayjs(startTimestamp).startOf('month').startOf('day')
  endTimestamp = +dayjs(endTimestamp).startOf('month').startOf('day')
  if (
    typeof startTimestamp !== 'number' &&
    typeof endTimestamp !== 'number' ||
    endTimestamp < startTimestamp
  ) {
    return []
  }
  const durationMonths = dayjs(endTimestamp).diff(dayjs(startTimestamp), 'month') + 1
  const monthRangeList = []
  for (let i = 0; i < durationMonths; i++) {
    monthRangeList.push(dayjs(startTimestamp).add(i, 'months').format('YYYY-MM'))
  }
  return monthRangeList
}

// 获取季度区间 数组
export function getQuarterRangeList(startTimestamp, endTimestamp) {
  startTimestamp = +dayjs(startTimestamp).startOf('quarter').startOf('day')
  endTimestamp = +dayjs(endTimestamp).endOf('quarter').startOf('day')

  if (
    typeof startTimestamp !== 'number' &&
    typeof endTimestamp !== 'number' ||
    endTimestamp < startTimestamp
  ) {
    return []
  }

  const durationQuarters = dayjs(endTimestamp).diff(dayjs(startTimestamp), 'quarter') + 1
  const quarterRangeList = []
  for (let i = 0; i < durationQuarters; i++) {
    quarterRangeList.push(dayjs(startTimestamp).add(i, 'quarters').format('YYYY-Q'))
  }
  return quarterRangeList
}

export function getDefaultMothPeriod () {
  const curDay = dayjs().date()
  if (curDay >= 15) {
    return [
      +dayjs().startOf('month').startOf('day'),
      +dayjs().endOf('month').startOf('day')
    ]
  } else {
    return [
      +dayjs().subtract(1, 'month').startOf('month').startOf('day'),
      +dayjs().subtract(1, 'month').endOf('month').startOf('day')
    ]
  }
}

export function getDefaultWeekPeriod () {
  const curWeekDay = dayjs().day()
  if (curWeekDay >= 2) {
    return [
      +dayjs().startOf('week').add(1, 'day').startOf('day'),
      +dayjs().endOf('week').startOf('day')
    ]
  } else {
    return [
      +dayjs().subtract(1, 'week').startOf('week').add(1, 'day').startOf('day'),
      +dayjs().subtract(1, 'week').endOf('week').startOf('day')
    ]
  }
}

export function getDefaultlastAWeekPeriod () {
  const lastMonday = +dayjs().subtract(1, 'week').startOf('week').add(1, 'day')
  const lastSunday = +dayjs(lastMonday).add(6, 'day')
  return [
    lastMonday, lastSunday
  ]
}

export function getDefaultABMonth (durationDays, num) {
  const dateRangeList = []
  for (let i = 0; i < num; i++) {
    /** (不能 加 i 天 的原因) **
     * 因为 durationDays 是一个 day日期对象，
     * 加上 dayjs 允许 修改 day对象 的行为
     * 所以 for 循环里面 durationDays 是已经被修改过 day对象 （就是已经 在了1天）
     * 结果 push dayjs 的日期只需要 永远加 1天即可
     *
     * 这里 涉及到 durationDays数据污染 问题
    */
    dateRangeList.push(dayjs(durationDays.add(1, 'day')).format('MM-DD'))
  }
  return dateRangeList
}

export function getDefaultlastWeekPeriod() {
  let testWeek = dayjs().day()
  const last_monday = dayjs().subtract( 4 * 7 + testWeek - 1, 'day')
  const last_sunday = dayjs().subtract(testWeek, 'day')
  return [+dayjs(last_monday).startOf('day'), +dayjs(last_sunday).startOf('day')]
}

export function formatNumberTo10kInt(num) {
  if (num) {
    num = numeral(num/10000).format('0,0.00')
    return num
  }
  return '--'
}

export function formatNumberTo10k(num) {
  num = numeral(num/10000).format('0,0')
  return num
}

export function formatAbsNumberTo10k(num) {
  return formatNumberTo10k(Math.abs(num))
}

export function formatNumber(number, exp = 1) {
  const f = parseFloat(number)
  if (isNaN(f)) {
    return Number(0).toFixed(exp)
  }
  return +f.toFixed(exp)
}

// 数据空值过滤
export function filterPickBy (query) {
  const codeKey = ['keyword', 'projectKeyword', 'project_keyword']
  const filterValue = R.pickBy((val, key) =>  val === '0' || val === 0 || val === false || val, query)
  for (let i = 0; i< codeKey.length; i ++) {
    filterValue[codeKey[i]]
      ? filterValue[codeKey[i]] = encodeURIComponent(filterValue[codeKey[i]])
      : ''
  }
  return filterValue
  // return R.pickBy((val, key) => val || val === 0, query)
  // return encodeURIComponent(filterValue)
}

export function getWeekPeriod() {
  return {
    startDate: +dayjs().startOf('week').add(1, 'day').startOf('day'),
    endDate: +dayjs().endOf('week').startOf('day')
    // startDate: +dayjs().day(1).startOf('day'),
    // endDate: +dayjs().day(7).startOf('day')
  }
}

// 根据传入年份 获取业务类型
export function getProjectBtType(year) {
  const formatYear = Number(year)
  const cutoffYear = 2024;
  let dataType = []

  switch (true) {
    case formatYear === cutoffYear: {
      dataType = [
        { key: 'projectBt', dataType:'cascaderData', disabled: true },
        { key: 'projectBtV2', dataType:'cascaderDataV2', disabled: false },
      ]
      break
    }
    case formatYear < cutoffYear: {
      dataType = [
        { key: 'projectBt', dataType:'cascaderData', disabled: true }
      ]
      break
    }
    case formatYear > cutoffYear: {  dataType = [
      { key: 'projectBtV2', dataType:'cascaderDataV2', disabled: true }
    ]
      break
    }
  }

  return dataType
}

// 根据传入数组，重组Select 退位树结构
export function getSelectTree(data, obj) {
  const { idKey, valueKey } = obj
  const generateSpaces = (count) => {
    return '\u00A0'.repeat(count); // 使用 Unicode 不间断空格
  }
  // 构建 嵌套Value
  const buildSelect = (data) => {
    const bData =  data.map(item => {
      const spliticon = item.parentIds.length === 0
        ? 0
        : item.parentIds.split(',').length
      const icon = generateSpaces(spliticon)
      return {
        ...item,
        id: item[idKey],
        value: `${icon}${spliticon > 0 ? '└': ''}${item[valueKey]}`,
      }
    })
    return bData
  }
  // // 构建嵌套结构
  // const buildTree = (data, parentId = '0') => {
  //   return data
  //     .filter(item => item.parentId === parentId)
  //     .map(item => {
  //       const spliticon = item.idPaths.split(',').length
  //       const icon = generateSpaces(spliticon - 1);

  //       return {
  //         ...item,
  //         id: item[idKey],
  //         value: `${icon}${spliticon > 1 ? '└': ''}${item[valueKey]}`,
  //         children: buildTree(data, item.id)
  //       }
  //     })
  // }
  // 展平嵌套结构
  const flattenTree = (tree) => {
    let result = []
    tree.forEach(node => {
      result.push(node);
      if (node.children && node.children.length > 0) {
        result = result.concat(flattenTree(node.children))
      }
    })
    return result
  }
  // 构建树形结构
  const formatData = buildSelect(data)

  const grouByData = R.groupBy(v => v.parentId, formatData)
  const tree = renderTree(grouByData)
  // 展平树形结构
  const sortedData = flattenTree(tree).map(item => {
    const { children, ...rest } = item
    return rest
  })
  return sortedData
}

/**
 * 检查并刷新 token 的通用方法
 * 
 * @param {Object} options - 配置选项
 * @param {number|null} options.expireTime - 过期时间戳（秒级），null 表示没有过期时间
 * @param {Function} options.getTokenAction - 获取 token 的 thunk action（如 getYs7Token, getJavaToken）
 * @param {Function} options.dispatch - Redux dispatch 函数
 * @param {Object} options.tokenParams - 传递给 getTokenAction 的参数（可选），如 { token: user.token }
 * @param {number} options.refreshThreshold - 刷新阈值（秒），默认 24 小时（86400 秒）。当剩余时间小于此值时刷新
 * @param {Function} options.onSuccess - 刷新成功回调，参数为 (result)
 * @param {Function} options.onError - 刷新失败回调，参数为 (error)
 * @param {string} options.tokenName - token 名称（用于日志），默认 'token'
 * 
 * @returns {boolean} 是否执行了刷新操作
 * 
 * @example
 * // 检查并刷新萤石云 token
 * checkAndRefreshToken({
 *   expireTime: ys7TokenExpireTime,
 *   getTokenAction: getYs7Token,
 *   dispatch,
 *   tokenName: '萤石云 token'
 * })
 * 
 * @example
 * // 检查并刷新 Java token（传入参数）
 * checkAndRefreshToken({
 *   expireTime: javaTokenExpireTime,
 *   getTokenAction: getJavaToken,
 *   dispatch,
 *   tokenParams: { token: user.token }, // 传递给 getJavaToken 的参数
 *   refreshThreshold: 12 * 60 * 60, // 12 小时
 *   tokenName: 'Java token',
 *   onSuccess: (result) => console.log('Java token 刷新成功', result),
 *   onError: (error) => console.error('Java token 刷新失败', error)
 * })
 */
export function checkAndRefreshToken(options = {}) {
  const {
    expireTime,
    getTokenAction,
    dispatch,
    tokenParams = {}, // 传递给 getTokenAction 的参数
    refreshThreshold = 24 * 60 * 60, // 默认 24 小时（秒）
    refreshWhenNoExpireTime = true, // 没有过期时间时是否刷新（默认刷新，防止拿不到 token）
    onSuccess,
    onError,
    tokenName = 'token'
  } = options

  // 规范化 expireTime：统一成“秒级时间戳”
  // - 支持传入毫秒时间戳（13位）
  // - 支持字符串数字
  const normalizeExpireTimeSec = (value) => {
    if (value === null || value === undefined || value === '') return null
    const num = Number(value)
    if (!Number.isFinite(num) || num <= 0) return null
    // 认为 >= 1e12 是毫秒时间戳（约 2001 年之后）
    return num >= 1e12 ? Math.floor(num / 1000) : Math.floor(num)
  }

  // 参数验证
  if (!getTokenAction) {
    console.warn('[checkAndRefreshToken] getTokenAction 参数是必需的')
    return false
  }
  if (!dispatch) {
    console.warn('[checkAndRefreshToken] dispatch 参数是必需的')
    return false
  }

  // 计算当前时间戳（秒）
  const currentTime = Math.floor(Date.now() / 1000)
  // 计算刷新阈值时间点（秒）
  const thresholdTime = currentTime + Number(refreshThreshold || 0)

  const expireTimeSec = normalizeExpireTimeSec(expireTime)

  // 判断是否需要刷新
  // 1. 没有过期时间
  // 2. 已过期
  // 3. 剩余时间小于刷新阈值
  const shouldRefresh =
    (refreshWhenNoExpireTime && !expireTimeSec) ||
    (expireTimeSec !== null && expireTimeSec < currentTime) ||
    (expireTimeSec !== null && expireTimeSec < thresholdTime)

  if (shouldRefresh) {
    // 执行刷新（如果 tokenParams 有值，则传入参数）
    const action = Object.keys(tokenParams).length > 0 
      ? getTokenAction(tokenParams)
      : getTokenAction()
    dispatch(action)
      .unwrap()
      .then((result) => {
        if (onSuccess) {
          onSuccess(result)
        } else {
          console.log(`${tokenName} 刷新成功`)
        }
      })
      .catch((error) => {
        if (onError) {
          onError(error)
        } else {
          console.warn(`${tokenName} 刷新失败:`, error)
        }
      })
    return true
  }

  return false
}

/**
 * 为需要加密的 API 接口准备数据
 * 用于 MemberController 等继承 CommonController 的接口
 * 需要将数据先进行 urldecode，然后 base64 编码
 * @param {Object} obj - 需要发送的数据对象
 * @returns {Object} - 包含加密数据的对象
 */
export function objToEncryptedData (obj = {}) {
  // 1. 将对象转换为 JSON 字符串（注意：后端需要将单引号替换为双引号）
  // 2. 对 JSON 字符串进行 URL 编码（encodeURIComponent）
  // 3. 对 URL 编码后的字符串进行 base64 编码
  const jsonStr = JSON.stringify(obj)
  const urlEncoded = encodeURIComponent(jsonStr)
  const base64Encoded = btoa(urlEncoded)

  return {
    data: base64Encoded
  }
}
